<template>
  <GenerateForm
    v-if="startParser"
    ref="GenerateForm"
    :form-conf="formConf"
    :question-mode="false"
    :pageSettingData="pageSettingData"
  />
</template>

<script>
import _ from 'lodash'
import GenerateForm from '../GenerateForm/index'
import { dbDataConvertForItemJson } from '@/utils/convert'
import request from '@/api/index'
import ThemeMixin from './ThemeMixin'
import { htmlDecodeByRegExp, removeHtmlTag } from '@/utils'
import { getFormLogicData, parserFormLogic } from './FormLogic'
import { getPublicSettingsRequest } from '@/api/project/setting'

export default {
  name: 'BizProjectForm',
  components: {
    GenerateForm
  },
  mixins: [ThemeMixin],
  props: {
    formConfig: {
      formKey: '',
      showBtns: true,
      // 项目种类  1 普通  2模板-->
      formKind: 1,
      showItem: 'start'
    },
    requestUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      startParser: false,
      parserKey: +new Date(),
      // 整个表单配置项
      formConf: {
        fields: [],
        logicShowRule: {}, // 逻辑显示规则
        formKey: '',
        // 表单类型  1 普通  2模板
        formKind: 1,
        formRef: 'elForm',
        formModel: 'formData',
        size: 'small',
        labelPosition: 'top',
        labelWidth: 100,
        formRules: 'rules',
        gutter: 15,
        disabled: false,
        span: 24,
        formBtns: true,
        resetBtn: false,
        submitBtnText: '提交',
        submitBtnColor: '#409EFF',
        showNumber: true,
        isShowItemQuestionNumber: false,
        unFocusedComponentBorder: true,
        // 每页数据
        perPageFields: {},
        // 设置内容
        setting: {}
      },
      // 一页多题
      pageSettingData: {
        pageShowMore: true // 默认为一页多题
      }
    }
  },
  computed: {},
  watch: {},
  async created() {
    // 父子组件props获取项目key
    if (this.formConfig && this.formConfig.formKey) {
      this.formConf.formKey = this.formConfig.formKey
      if (this.formConfig.formKind) {
        this.formConf.formKind = this.formConfig.formKind
      }
      // iframe 从路由中尝试获取
    } else if (this.$route.query.key) {
      this.formConf.formKey = this.$route.query.key
      if (this.$route.query.kind) {
        this.formConf.formKind = this.$route.query.kind
      }
      this.formConf.formBtns = true
    }
    this.formConf.setting = this.formConfig.setting
    this.formConf.isPcOrMobile = this.formConfig.isPcOrMobile
    this.formConf.size = window.innerWidth < 480 ? 'medium' : 'small'
  },
  async mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.pageSettingData = await this.queryUserProjectSetting(this.formConf.formKey)
      const { requestUrl, formConf } = this
      // 是模板还是用户自定义表单
      let url = requestUrl ? requestUrl : `/user/form/details/${formConf.formKey}`
      if (formConf.formKind === 2) {
        url = `/form/template/details/${formConf.formKey}`
      }
      // 请求表单详细数据
      const { data } = await request.get(url)
      if (data) {
        // 处理逻辑表单
        let { logicTriggerRules, hiddenFormItemIds } = parserFormLogic(data)
        // 主题数据
        const enable = data.defineTheme.enable
        this.formConf.theme = enable === 1 ? data.defineTheme : data.userFormTheme
        // 设置了隐藏开始答题页，进入问卷直接到答题页
        this.formConf.showItem = enable && data.defineTheme.isDisableStartPage ? 'project' : 'start'
        if (data.userFormTheme && !enable) {
          const { submitBtnText, showNumber, themeColor, isShowItemQuestionNumber } = data.userFormTheme
          if (submitBtnText) this.formConf.theme.submitBtnText = submitBtnText
          if (showNumber) this.formConf.theme.showNumber = showNumber
          // 展示题号
          if (isShowItemQuestionNumber) this.formConf.theme.isShowItemQuestionNumber = isShowItemQuestionNumber
          // 主题颜色
          if (themeColor) {
            document.documentElement.style.setProperty('--form-theme-color', themeColor)
          }
        }
        // 处理表单问题项
        const fields = data.formItems.map((item) => {
          const projectItem = dbDataConvertForItemJson(item, data.formItemOptionsExtension[item.formItemId] || [])
          // 是否是逻辑控制显示字段
          projectItem.logicShowField = hiddenFormItemIds.get(projectItem.formItemId) !== undefined
          return projectItem
        })
        if (this.pageSettingData.pageShowMore) {
          this.pageShowHandle(fields)
        } else {
          this.pageShowSingle(fields)
        }
        if (_.keys(formConf.perPageFields).length !== 0) {
          this.formConf.fields = _.get(formConf.perPageFields, 1)
          this.formConf.formBtns = false
        } else {
          this.formConf.fields = fields
        }
        if (data.form) {
          this.formConf.title = data.form.name
          document.title = htmlDecodeByRegExp(removeHtmlTag(data.form.name))
          this.formConf.description = data.form.description
          this.formConf.formType = data.form.type
        }
        this.formConf.logicShowRule = logicTriggerRules
        this.startParser = true

        // 加载完成后触发 给上级页面完成一些操作
        this.$emit('completed')
      }
    },
    // 获取问卷设置
    async queryUserProjectSetting(key) {
      // 填写设置
      let { data } = await getPublicSettingsRequest(key)
      const settingData = {}
      if (data) {
        const typeVal = data.pageShowType ? data.pageShowType : 'more'
        settingData.pageShowMore = typeVal === 'more' ? true : false
        settingData.submitShowCustomPageContent = data.submitShowCustomPageContent
          ? data.submitShowCustomPageContent
          : '提交成功'
      } else {
        settingData.pageShowMore = true
        settingData.submitShowCustomPageContent = '提交成功'
      }
      return settingData
    },
    // 分页显示数据处理
    pageShowHandle(allFields) {
      // 判断是否存在分页
      const index = allFields.findIndex((item) => item.typeId === 'PAGINATION')
      if (index < 0) {
        return
      }
      let curr = 1
      // 每页字段
      const perPageFields = {}
      // 临时存储分页控制数据
      const pageFields = {}
      // 遍历所有字段 把不同页的组件归类到对象的同一个key下
      allFields.forEach((item) => {
        let fields = _.get(perPageFields, curr)
        if (item.typeId === 'PAGINATION') {
          _.set(pageFields, curr, item)
          // 判断当前页是否有组件 如果没有组件则认为是一个无效的分页组件，页数则不+1
          if (fields) {
            item.currPageNum = curr++
          }
        } else {
          if (!fields || fields === undefined) {
            fields = []
          }
          fields.push(item)
          _.set(perPageFields, curr, fields)
        }
      })
      const len = _.keys(perPageFields).length
      // 计算总页数 为每个分页控件绑定数据 并把分页控件添加到每页的控件数据末尾，
      // 并且为最后一页默认生成一个分页控件 否则不拖动将无法返回第一页
      _.keys(perPageFields).forEach((key) => {
        const pageItem = _.get(pageFields, key)
        if (pageItem) {
          const fields = _.get(perPageFields, key)
          pageItem.totalPageNum = len
          fields.push(pageItem)
          _.set(perPageFields, key, fields)
        }
        // 特殊处理最后一页 如果没有主动拖分页 则默认添加一个
        else {
          let defaultPageItem = _.cloneDeep(_.get(pageFields, 1))
          const fields = _.get(perPageFields, key)
          defaultPageItem.totalPageNum = len
          defaultPageItem.currPageNum = len
          fields.push(defaultPageItem)
          _.set(perPageFields, key, fields)
        }
      })
      this.formConf.perPageFields = perPageFields
    },
    pageShowSingle(allFields) {
      // 每页字段
      const perPageFields = {}
      // 遍历所有字段 把不同页的组件归类到对象的同一个key下
      allFields.forEach((item, idx) => {
        item.currPageNum = idx + 1
        item.totalPageNum = allFields.length
        _.set(perPageFields, idx + 1, [item])
      })
      this.formConf.perPageFields = perPageFields
    },
    // 获取逻辑成立的数据
    getLogicShowData(data) {
      return getFormLogicData(data, this.formConf.logicShowRule)
    },
    changeFormConfig() {
      if (this.$refs.GenerateForm) {
        this.$refs.GenerateForm.getShowModule(this.formConfig.showItem)
      }
    }
  }
}
</script>
<style lang="scss">
$themeColor: var(--form-theme-color);
@import '../../../assets/styles/custom-theme-popper.scss';
</style>

<style lang="scss" scoped>
$themeColor: var(--form-theme-color);
@import '../../../assets/styles/custom-theme.scss';
</style>
